import { render } from "./prompt.vue?vue&type=template&id=6b9b5bd3"
import script from "./Prompt.ts?vue&type=script&lang=js&external"
export * from "./Prompt.ts?vue&type=script&lang=js&external"

import "./Prompt.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__